export const LIST_USER = 'LIST_USER'
export const DETAIL_USER = 'DETAIL_USER'
export const TOTAL_USER = 'TOTAL_USER'
export const LIST_MEMBER_INFINITE = 'LIST_MEMBER_INFINITE'
